export default __webpack_public_path__ + "static/media/powerbi.7531d73a.svg";